import { Facet } from '../models/Facet';

export const isSortableFacet: Facet<boolean> = new Facet('sortable');

export const isGroupableFacet: Facet<boolean> = new Facet('groupable');

export const isFilterableFacet: Facet<boolean> = new Facet('filterable');

export const isEditableFacet: Facet<boolean> = new Facet('editable');

export const isRequiredFacet: Facet<boolean> = new Facet('required');